import {
  defaultBaseQuery,
  transformRequest,
  transformErrorResponse,
  transformSuccessResponse,
} from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const instituteLocationAPI = createApi({
  reducerPath: "instituteLocationAPI",
  baseQuery: defaultBaseQuery,
  tagTypes: ["InstituteLocation"],
  endpoints: (builder) => ({
    getInstituteLocation: builder.query({
      query: () => ({
        url: `/location`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      providesTags: ["InstituteLocation"],
    }),
    saveInstituteLocation: builder.mutation({
      query: (data) => ({
        url: `/location`,
        method: "POST",
        body: transformRequest(data),
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      invalidatesTags: ["InstituteLocation"],
    }),
  }),
});

export const {
  useGetInstituteLocationQuery,
  useSaveInstituteLocationMutation,
} = instituteLocationAPI;

export default instituteLocationAPI;
